import React from 'react'
import styled, { css } from 'styled-components'

import { ArrowLeftSVG } from '../SVGS/ArrowLeftSVG'
import { CaretDown } from '../SVGS/CaretDown'
import { CaretLeft } from '../SVGS/CaretLeft'
import { CaretRight } from '../SVGS/CaretRight'
import { CaretUp } from '../SVGS/CaretUp'
import { CrossSVG } from '../SVGS/CrossSVG'
import { MinusSVG } from '../SVGS/MinusSVG'
import { PlusSVG } from '../SVGS/PlusSVG'
import { LocationPinSVG } from '../SVGS/LocationPinSVG'

type Color = {
  default: string
  hover: string
}

const Container = styled.button<{
  size: number
  disabled?: boolean
  bordered: boolean
  backgroundColor?: Color
  stroke?: Color
}>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  color: ${({ theme, stroke }) => stroke?.default || theme.colors.brand};
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor?.default || theme.colors.grey};
  border: none;
  border-radius: 50%;
  transition: color, background-color 0.3s;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${({ stroke }) => stroke?.hover || '#fff'};
    border: ${({ stroke, bordered }) =>
      stroke?.hover && bordered ? `2px solid ${stroke.hover}` : 'none'};
    background-color: ${({ theme, backgroundColor }) =>
      backgroundColor?.hover || theme.colors.brand};
  }

  & svg {
    display: block;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.2;
      pointer-events: none;
      color: #00000;
      cursor: default;
    `}
`
type IconKey =
  | 'plus'
  | 'minus'
  | 'cross'
  | 'caretUp'
  | 'caretDown'
  | 'arrowBack'
  | 'caretLeft'
  | 'caretRight'

export const IconButton: React.VFC<{
  onClick?: (e: React.MouseEvent<HTMLElement>) => void
  disabled?: boolean
  bordered?: boolean
  icon: string
  size?: number
  alt?: string
  backgroundColor?: Color
  stroke?: Color
  className?: string
  role?: string
  style?: Record<string, any>
}> = ({
  onClick,
  disabled = false,
  bordered = true,
  icon = 'plus',
  size = 32,
  alt,
  backgroundColor,
  stroke,
  className,
  role,
  style = {},
}) => {
  const iconMap = {
    plus: <PlusSVG id="plus" title={alt} />,
    minus: <MinusSVG id="minus" title={alt} />,
    cross: <CrossSVG id="close" title={alt} />,
    caretUp: <CaretUp id="expand" title={alt} />,
    caretDown: <CaretDown id="collapse" title={alt} />,
    arrowBack: <ArrowLeftSVG id="back" title={alt} />,
    caretLeft: <CaretLeft id="left" title={alt} />,
    caretRight: <CaretRight id="right" title={alt} />,
    locationPin: <LocationPinSVG id="location-pin" />,
  }

  const iconKey: IconKey = icon as IconKey
  return (
    <Container
      className={className}
      disabled={disabled}
      bordered={bordered}
      onClick={onClick}
      size={size}
      backgroundColor={backgroundColor}
      stroke={stroke}
      role={role}
      style={style}
    >
      {iconMap[iconKey]}
    </Container>
  )
}
